/**
 * Do not edit directly
 * Generated on Wed, 03 Jan 2024 13:40:28 GMT
 */

module.exports = {
  "breakpoint": {
    "xs": {
      "value": "0px",
      "comment": "Commonly used for mobile resolutions.",
      "filePath": "src/breakpoint/sys.json",
      "isSource": true,
      "original": {
        "value": "0px",
        "comment": "Commonly used for mobile resolutions."
      },
      "name": "BreakpointXs",
      "attributes": {
        "category": "breakpoint",
        "type": "xs"
      },
      "path": [
        "breakpoint",
        "xs"
      ]
    },
    "md": {
      "value": "672px",
      "comment": "Commonly used for tablet resolutions.",
      "filePath": "src/breakpoint/sys.json",
      "isSource": true,
      "original": {
        "value": "672px",
        "comment": "Commonly used for tablet resolutions."
      },
      "name": "BreakpointMd",
      "attributes": {
        "category": "breakpoint",
        "type": "md"
      },
      "path": [
        "breakpoint",
        "md"
      ]
    },
    "lg": {
      "value": "1024px",
      "comment": "Commonly used for small desktop resolutions.",
      "filePath": "src/breakpoint/sys.json",
      "isSource": true,
      "original": {
        "value": "1024px",
        "comment": "Commonly used for small desktop resolutions."
      },
      "name": "BreakpointLg",
      "attributes": {
        "category": "breakpoint",
        "type": "lg"
      },
      "path": [
        "breakpoint",
        "lg"
      ]
    },
    "xl": {
      "value": "1200px",
      "comment": "Commonly used for bigger desktop resolutions.",
      "filePath": "src/breakpoint/sys.json",
      "isSource": true,
      "original": {
        "value": "1200px",
        "comment": "Commonly used for bigger desktop resolutions."
      },
      "name": "BreakpointXl",
      "attributes": {
        "category": "breakpoint",
        "type": "xl"
      },
      "path": [
        "breakpoint",
        "xl"
      ]
    }
  },
  "color": {
    "light": {
      "primary": {
        "5": {
          "value": "#000b19",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#000B19"
          },
          "name": "ColorLightPrimary5",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "primary",
            "subitem": "5"
          },
          "path": [
            "color",
            "light",
            "primary",
            "5"
          ]
        },
        "10": {
          "value": "#001737",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#001737"
          },
          "name": "ColorLightPrimary10",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "primary",
            "subitem": "10"
          },
          "path": [
            "color",
            "light",
            "primary",
            "10"
          ]
        },
        "20": {
          "value": "#00255a",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#00255A"
          },
          "name": "ColorLightPrimary20",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "primary",
            "subitem": "20"
          },
          "path": [
            "color",
            "light",
            "primary",
            "20"
          ]
        },
        "30": {
          "value": "#00347d",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#00347D"
          },
          "name": "ColorLightPrimary30",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "primary",
            "subitem": "30"
          },
          "path": [
            "color",
            "light",
            "primary",
            "30"
          ]
        },
        "40": {
          "value": "#00429f",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#00429F"
          },
          "name": "ColorLightPrimary40",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "primary",
            "subitem": "40"
          },
          "path": [
            "color",
            "light",
            "primary",
            "40"
          ]
        },
        "50": {
          "value": "#004ebc",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#004EBC"
          },
          "name": "ColorLightPrimary50",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "primary",
            "subitem": "50"
          },
          "path": [
            "color",
            "light",
            "primary",
            "50"
          ]
        },
        "60": {
          "value": "#0059d5",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#0059D5"
          },
          "name": "ColorLightPrimary60",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "primary",
            "subitem": "60"
          },
          "path": [
            "color",
            "light",
            "primary",
            "60"
          ]
        },
        "70": {
          "value": "#2577e9",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#2577E9"
          },
          "name": "ColorLightPrimary70",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "primary",
            "subitem": "70"
          },
          "path": [
            "color",
            "light",
            "primary",
            "70"
          ]
        },
        "80": {
          "value": "#4b92f5",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#4B92F5"
          },
          "name": "ColorLightPrimary80",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "primary",
            "subitem": "80"
          },
          "path": [
            "color",
            "light",
            "primary",
            "80"
          ]
        },
        "90": {
          "value": "#96c1fc",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#96C1FC"
          },
          "name": "ColorLightPrimary90",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "primary",
            "subitem": "90"
          },
          "path": [
            "color",
            "light",
            "primary",
            "90"
          ]
        },
        "95": {
          "value": "#c2dbfe",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#C2DBFE"
          },
          "name": "ColorLightPrimary95",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "primary",
            "subitem": "95"
          },
          "path": [
            "color",
            "light",
            "primary",
            "95"
          ]
        },
        "99": {
          "value": "#eef5ff",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#EEF5FF"
          },
          "name": "ColorLightPrimary99",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "primary",
            "subitem": "99"
          },
          "path": [
            "color",
            "light",
            "primary",
            "99"
          ]
        },
        "100": {
          "value": "#ffffff",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#FFFFFF"
          },
          "name": "ColorLightPrimary100",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "primary",
            "subitem": "100"
          },
          "path": [
            "color",
            "light",
            "primary",
            "100"
          ]
        },
        "surface": {
          "value": "#eef5ff",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.primary.99}"
          },
          "name": "ColorLightPrimarySurface",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "primary",
            "subitem": "surface"
          },
          "path": [
            "color",
            "light",
            "primary",
            "surface"
          ]
        },
        "surface-highlight": {
          "value": "#96c1fc",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.primary.90}"
          },
          "name": "ColorLightPrimarySurfaceHighlight",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "primary",
            "subitem": "surface-highlight"
          },
          "path": [
            "color",
            "light",
            "primary",
            "surface-highlight"
          ]
        },
        "interactive": {
          "value": "#0059d5",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.primary.60}"
          },
          "name": "ColorLightPrimaryInteractive",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "primary",
            "subitem": "interactive"
          },
          "path": [
            "color",
            "light",
            "primary",
            "interactive"
          ]
        },
        "interactive-hover": {
          "value": "#00429f",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.primary.40}"
          },
          "name": "ColorLightPrimaryInteractiveHover",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "primary",
            "subitem": "interactive-hover"
          },
          "path": [
            "color",
            "light",
            "primary",
            "interactive-hover"
          ]
        },
        "interactive-pressed": {
          "value": "#00347d",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.primary.30}"
          },
          "name": "ColorLightPrimaryInteractivePressed",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "primary",
            "subitem": "interactive-pressed"
          },
          "path": [
            "color",
            "light",
            "primary",
            "interactive-pressed"
          ]
        },
        "text-low": {
          "value": "#00255a",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.primary.20}"
          },
          "name": "ColorLightPrimaryTextLow",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "primary",
            "subitem": "text-low"
          },
          "path": [
            "color",
            "light",
            "primary",
            "text-low"
          ]
        },
        "text-high": {
          "value": "#000b19",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.primary.5}"
          },
          "name": "ColorLightPrimaryTextHigh",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "primary",
            "subitem": "text-high"
          },
          "path": [
            "color",
            "light",
            "primary",
            "text-high"
          ]
        }
      },
      "success": {
        "5": {
          "value": "#001910",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#001910"
          },
          "name": "ColorLightSuccess5",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "success",
            "subitem": "5"
          },
          "path": [
            "color",
            "light",
            "success",
            "5"
          ]
        },
        "10": {
          "value": "#003420",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#003420"
          },
          "name": "ColorLightSuccess10",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "success",
            "subitem": "10"
          },
          "path": [
            "color",
            "light",
            "success",
            "10"
          ]
        },
        "20": {
          "value": "#005333",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#005333"
          },
          "name": "ColorLightSuccess20",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "success",
            "subitem": "20"
          },
          "path": [
            "color",
            "light",
            "success",
            "20"
          ]
        },
        "30": {
          "value": "#007447",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#007447"
          },
          "name": "ColorLightSuccess30",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "success",
            "subitem": "30"
          },
          "path": [
            "color",
            "light",
            "success",
            "30"
          ]
        },
        "40": {
          "value": "#00935b",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#00935B"
          },
          "name": "ColorLightSuccess40",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "success",
            "subitem": "40"
          },
          "path": [
            "color",
            "light",
            "success",
            "40"
          ]
        },
        "50": {
          "value": "#00af6c",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#00AF6C"
          },
          "name": "ColorLightSuccess50",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "success",
            "subitem": "50"
          },
          "path": [
            "color",
            "light",
            "success",
            "50"
          ]
        },
        "60": {
          "value": "#00c87b",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#00C87B"
          },
          "name": "ColorLightSuccess60",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "success",
            "subitem": "60"
          },
          "path": [
            "color",
            "light",
            "success",
            "60"
          ]
        },
        "70": {
          "value": "#0fdc8e",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#0FDC8E"
          },
          "name": "ColorLightSuccess70",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "success",
            "subitem": "70"
          },
          "path": [
            "color",
            "light",
            "success",
            "70"
          ]
        },
        "80": {
          "value": "#3feca9",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#3FECA9"
          },
          "name": "ColorLightSuccess80",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "success",
            "subitem": "80"
          },
          "path": [
            "color",
            "light",
            "success",
            "80"
          ]
        },
        "90": {
          "value": "#7af7c7",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#7AF7C7"
          },
          "name": "ColorLightSuccess90",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "success",
            "subitem": "90"
          },
          "path": [
            "color",
            "light",
            "success",
            "90"
          ]
        },
        "95": {
          "value": "#bcfde4",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#BCFDE4"
          },
          "name": "ColorLightSuccess95",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "success",
            "subitem": "95"
          },
          "path": [
            "color",
            "light",
            "success",
            "95"
          ]
        },
        "99": {
          "value": "#defef2",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#DEFEF2"
          },
          "name": "ColorLightSuccess99",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "success",
            "subitem": "99"
          },
          "path": [
            "color",
            "light",
            "success",
            "99"
          ]
        },
        "100": {
          "value": "#ffffff",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#FFFFFF"
          },
          "name": "ColorLightSuccess100",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "success",
            "subitem": "100"
          },
          "path": [
            "color",
            "light",
            "success",
            "100"
          ]
        },
        "surface": {
          "value": "#defef2",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.success.99}"
          },
          "name": "ColorLightSuccessSurface",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "success",
            "subitem": "surface"
          },
          "path": [
            "color",
            "light",
            "success",
            "surface"
          ]
        },
        "surface-highlight": {
          "value": "#7af7c7",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.success.90}"
          },
          "name": "ColorLightSuccessSurfaceHighlight",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "success",
            "subitem": "surface-highlight"
          },
          "path": [
            "color",
            "light",
            "success",
            "surface-highlight"
          ]
        },
        "interactive": {
          "value": "#00c87b",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.success.60}"
          },
          "name": "ColorLightSuccessInteractive",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "success",
            "subitem": "interactive"
          },
          "path": [
            "color",
            "light",
            "success",
            "interactive"
          ]
        },
        "interactive-hover": {
          "value": "#00935b",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.success.40}"
          },
          "name": "ColorLightSuccessInteractiveHover",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "success",
            "subitem": "interactive-hover"
          },
          "path": [
            "color",
            "light",
            "success",
            "interactive-hover"
          ]
        },
        "interactive-pressed": {
          "value": "#007447",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.success.30}"
          },
          "name": "ColorLightSuccessInteractivePressed",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "success",
            "subitem": "interactive-pressed"
          },
          "path": [
            "color",
            "light",
            "success",
            "interactive-pressed"
          ]
        },
        "text-low": {
          "value": "#005333",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.success.20}"
          },
          "name": "ColorLightSuccessTextLow",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "success",
            "subitem": "text-low"
          },
          "path": [
            "color",
            "light",
            "success",
            "text-low"
          ]
        },
        "text-high": {
          "value": "#001910",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.success.5}"
          },
          "name": "ColorLightSuccessTextHigh",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "success",
            "subitem": "text-high"
          },
          "path": [
            "color",
            "light",
            "success",
            "text-high"
          ]
        }
      },
      "warning": {
        "5": {
          "value": "#191000",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#191000"
          },
          "name": "ColorLightWarning5",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "warning",
            "subitem": "5"
          },
          "path": [
            "color",
            "light",
            "warning",
            "5"
          ]
        },
        "10": {
          "value": "#342000",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#342000"
          },
          "name": "ColorLightWarning10",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "warning",
            "subitem": "10"
          },
          "path": [
            "color",
            "light",
            "warning",
            "10"
          ]
        },
        "20": {
          "value": "#533300",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#533300"
          },
          "name": "ColorLightWarning20",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "warning",
            "subitem": "20"
          },
          "path": [
            "color",
            "light",
            "warning",
            "20"
          ]
        },
        "30": {
          "value": "#744700",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#744700"
          },
          "name": "ColorLightWarning30",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "warning",
            "subitem": "30"
          },
          "path": [
            "color",
            "light",
            "warning",
            "30"
          ]
        },
        "40": {
          "value": "#935b00",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#935B00"
          },
          "name": "ColorLightWarning40",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "warning",
            "subitem": "40"
          },
          "path": [
            "color",
            "light",
            "warning",
            "40"
          ]
        },
        "50": {
          "value": "#af6c00",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#AF6C00"
          },
          "name": "ColorLightWarning50",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "warning",
            "subitem": "50"
          },
          "path": [
            "color",
            "light",
            "warning",
            "50"
          ]
        },
        "60": {
          "value": "#c87b00",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#C87B00"
          },
          "name": "ColorLightWarning60",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "warning",
            "subitem": "60"
          },
          "path": [
            "color",
            "light",
            "warning",
            "60"
          ]
        },
        "70": {
          "value": "#dc8e0f",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#DC8E0F"
          },
          "name": "ColorLightWarning70",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "warning",
            "subitem": "70"
          },
          "path": [
            "color",
            "light",
            "warning",
            "70"
          ]
        },
        "80": {
          "value": "#eca93f",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#ECA93F"
          },
          "name": "ColorLightWarning80",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "warning",
            "subitem": "80"
          },
          "path": [
            "color",
            "light",
            "warning",
            "80"
          ]
        },
        "90": {
          "value": "#f7c77a",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#F7C77A"
          },
          "name": "ColorLightWarning90",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "warning",
            "subitem": "90"
          },
          "path": [
            "color",
            "light",
            "warning",
            "90"
          ]
        },
        "95": {
          "value": "#fde4bc",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#FDE4BC"
          },
          "name": "ColorLightWarning95",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "warning",
            "subitem": "95"
          },
          "path": [
            "color",
            "light",
            "warning",
            "95"
          ]
        },
        "99": {
          "value": "#fef2de",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#FEF2DE"
          },
          "name": "ColorLightWarning99",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "warning",
            "subitem": "99"
          },
          "path": [
            "color",
            "light",
            "warning",
            "99"
          ]
        },
        "100": {
          "value": "#ffffff",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#FFFFFF"
          },
          "name": "ColorLightWarning100",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "warning",
            "subitem": "100"
          },
          "path": [
            "color",
            "light",
            "warning",
            "100"
          ]
        },
        "surface": {
          "value": "#fef2de",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.warning.99}"
          },
          "name": "ColorLightWarningSurface",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "warning",
            "subitem": "surface"
          },
          "path": [
            "color",
            "light",
            "warning",
            "surface"
          ]
        },
        "surface-highlight": {
          "value": "#f7c77a",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.warning.90}"
          },
          "name": "ColorLightWarningSurfaceHighlight",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "warning",
            "subitem": "surface-highlight"
          },
          "path": [
            "color",
            "light",
            "warning",
            "surface-highlight"
          ]
        },
        "interactive": {
          "value": "#c87b00",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.warning.60}"
          },
          "name": "ColorLightWarningInteractive",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "warning",
            "subitem": "interactive"
          },
          "path": [
            "color",
            "light",
            "warning",
            "interactive"
          ]
        },
        "interactive-hover": {
          "value": "#935b00",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.warning.40}"
          },
          "name": "ColorLightWarningInteractiveHover",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "warning",
            "subitem": "interactive-hover"
          },
          "path": [
            "color",
            "light",
            "warning",
            "interactive-hover"
          ]
        },
        "interactive-pressed": {
          "value": "#744700",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.warning.30}"
          },
          "name": "ColorLightWarningInteractivePressed",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "warning",
            "subitem": "interactive-pressed"
          },
          "path": [
            "color",
            "light",
            "warning",
            "interactive-pressed"
          ]
        },
        "text-low": {
          "value": "#533300",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.warning.20}"
          },
          "name": "ColorLightWarningTextLow",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "warning",
            "subitem": "text-low"
          },
          "path": [
            "color",
            "light",
            "warning",
            "text-low"
          ]
        },
        "text-high": {
          "value": "#191000",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.warning.5}"
          },
          "name": "ColorLightWarningTextHigh",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "warning",
            "subitem": "text-high"
          },
          "path": [
            "color",
            "light",
            "warning",
            "text-high"
          ]
        }
      },
      "danger": {
        "5": {
          "value": "#190000",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#190000"
          },
          "name": "ColorLightDanger5",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "danger",
            "subitem": "5"
          },
          "path": [
            "color",
            "light",
            "danger",
            "5"
          ]
        },
        "10": {
          "value": "#340001",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#340001"
          },
          "name": "ColorLightDanger10",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "danger",
            "subitem": "10"
          },
          "path": [
            "color",
            "light",
            "danger",
            "10"
          ]
        },
        "20": {
          "value": "#530001",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#530001"
          },
          "name": "ColorLightDanger20",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "danger",
            "subitem": "20"
          },
          "path": [
            "color",
            "light",
            "danger",
            "20"
          ]
        },
        "30": {
          "value": "#740002",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#740002"
          },
          "name": "ColorLightDanger30",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "danger",
            "subitem": "30"
          },
          "path": [
            "color",
            "light",
            "danger",
            "30"
          ]
        },
        "40": {
          "value": "#930002",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#930002"
          },
          "name": "ColorLightDanger40",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "danger",
            "subitem": "40"
          },
          "path": [
            "color",
            "light",
            "danger",
            "40"
          ]
        },
        "50": {
          "value": "#af0003",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#AF0003"
          },
          "name": "ColorLightDanger50",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "danger",
            "subitem": "50"
          },
          "path": [
            "color",
            "light",
            "danger",
            "50"
          ]
        },
        "60": {
          "value": "#c80003",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#C80003"
          },
          "name": "ColorLightDanger60",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "danger",
            "subitem": "60"
          },
          "path": [
            "color",
            "light",
            "danger",
            "60"
          ]
        },
        "70": {
          "value": "#dc0f13",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#DC0F13"
          },
          "name": "ColorLightDanger70",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "danger",
            "subitem": "70"
          },
          "path": [
            "color",
            "light",
            "danger",
            "70"
          ]
        },
        "80": {
          "value": "#ec3f41",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#EC3F41"
          },
          "name": "ColorLightDanger80",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "danger",
            "subitem": "80"
          },
          "path": [
            "color",
            "light",
            "danger",
            "80"
          ]
        },
        "90": {
          "value": "#f77a7c",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#F77A7C"
          },
          "name": "ColorLightDanger90",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "danger",
            "subitem": "90"
          },
          "path": [
            "color",
            "light",
            "danger",
            "90"
          ]
        },
        "95": {
          "value": "#fdbcbd",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#FDBCBD"
          },
          "name": "ColorLightDanger95",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "danger",
            "subitem": "95"
          },
          "path": [
            "color",
            "light",
            "danger",
            "95"
          ]
        },
        "99": {
          "value": "#fedede",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#FEDEDE"
          },
          "name": "ColorLightDanger99",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "danger",
            "subitem": "99"
          },
          "path": [
            "color",
            "light",
            "danger",
            "99"
          ]
        },
        "100": {
          "value": "#ffffff",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#FFFFFF"
          },
          "name": "ColorLightDanger100",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "danger",
            "subitem": "100"
          },
          "path": [
            "color",
            "light",
            "danger",
            "100"
          ]
        },
        "surface": {
          "value": "#fedede",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.danger.99}"
          },
          "name": "ColorLightDangerSurface",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "danger",
            "subitem": "surface"
          },
          "path": [
            "color",
            "light",
            "danger",
            "surface"
          ]
        },
        "surface-highlight": {
          "value": "#f77a7c",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.danger.90}"
          },
          "name": "ColorLightDangerSurfaceHighlight",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "danger",
            "subitem": "surface-highlight"
          },
          "path": [
            "color",
            "light",
            "danger",
            "surface-highlight"
          ]
        },
        "interactive": {
          "value": "#c80003",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.danger.60}"
          },
          "name": "ColorLightDangerInteractive",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "danger",
            "subitem": "interactive"
          },
          "path": [
            "color",
            "light",
            "danger",
            "interactive"
          ]
        },
        "interactive-hover": {
          "value": "#930002",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.danger.40}"
          },
          "name": "ColorLightDangerInteractiveHover",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "danger",
            "subitem": "interactive-hover"
          },
          "path": [
            "color",
            "light",
            "danger",
            "interactive-hover"
          ]
        },
        "interactive-pressed": {
          "value": "#740002",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.danger.30}"
          },
          "name": "ColorLightDangerInteractivePressed",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "danger",
            "subitem": "interactive-pressed"
          },
          "path": [
            "color",
            "light",
            "danger",
            "interactive-pressed"
          ]
        },
        "text-low": {
          "value": "#530001",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.danger.20}"
          },
          "name": "ColorLightDangerTextLow",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "danger",
            "subitem": "text-low"
          },
          "path": [
            "color",
            "light",
            "danger",
            "text-low"
          ]
        },
        "text-high": {
          "value": "#190000",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.danger.5}"
          },
          "name": "ColorLightDangerTextHigh",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "danger",
            "subitem": "text-high"
          },
          "path": [
            "color",
            "light",
            "danger",
            "text-high"
          ]
        }
      },
      "neutral": {
        "0": {
          "value": "#0a0a0a",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#0A0A0A"
          },
          "name": "ColorLightNeutral0",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "neutral",
            "subitem": "0"
          },
          "path": [
            "color",
            "light",
            "neutral",
            "0"
          ]
        },
        "5": {
          "value": "#1f2020",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#1F2020"
          },
          "name": "ColorLightNeutral5",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "neutral",
            "subitem": "5"
          },
          "path": [
            "color",
            "light",
            "neutral",
            "5"
          ]
        },
        "10": {
          "value": "#3d3d3d",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#3D3D3D"
          },
          "name": "ColorLightNeutral10",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "neutral",
            "subitem": "10"
          },
          "path": [
            "color",
            "light",
            "neutral",
            "10"
          ]
        },
        "20": {
          "value": "#454545",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#454545"
          },
          "name": "ColorLightNeutral20",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "neutral",
            "subitem": "20"
          },
          "path": [
            "color",
            "light",
            "neutral",
            "20"
          ]
        },
        "30": {
          "value": "#4f4f4f",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#4F4F4F"
          },
          "name": "ColorLightNeutral30",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "neutral",
            "subitem": "30"
          },
          "path": [
            "color",
            "light",
            "neutral",
            "30"
          ]
        },
        "40": {
          "value": "#5d5d5d",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#5D5D5D"
          },
          "name": "ColorLightNeutral40",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "neutral",
            "subitem": "40"
          },
          "path": [
            "color",
            "light",
            "neutral",
            "40"
          ]
        },
        "50": {
          "value": "#6d6d6d",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#6D6D6D"
          },
          "name": "ColorLightNeutral50",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "neutral",
            "subitem": "50"
          },
          "path": [
            "color",
            "light",
            "neutral",
            "50"
          ]
        },
        "60": {
          "value": "#777777",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#777777"
          },
          "name": "ColorLightNeutral60",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "neutral",
            "subitem": "60"
          },
          "path": [
            "color",
            "light",
            "neutral",
            "60"
          ]
        },
        "70": {
          "value": "#888888",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#888888"
          },
          "name": "ColorLightNeutral70",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "neutral",
            "subitem": "70"
          },
          "path": [
            "color",
            "light",
            "neutral",
            "70"
          ]
        },
        "80": {
          "value": "#b0b0b0",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#B0B0B0"
          },
          "name": "ColorLightNeutral80",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "neutral",
            "subitem": "80"
          },
          "path": [
            "color",
            "light",
            "neutral",
            "80"
          ]
        },
        "90": {
          "value": "#d1d1d1",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#D1D1D1"
          },
          "name": "ColorLightNeutral90",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "neutral",
            "subitem": "90"
          },
          "path": [
            "color",
            "light",
            "neutral",
            "90"
          ]
        },
        "95": {
          "value": "#e7e7e7",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#E7E7E7"
          },
          "name": "ColorLightNeutral95",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "neutral",
            "subitem": "95"
          },
          "path": [
            "color",
            "light",
            "neutral",
            "95"
          ]
        },
        "99": {
          "value": "#f6f6f6",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#F6F6F6"
          },
          "name": "ColorLightNeutral99",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "neutral",
            "subitem": "99"
          },
          "path": [
            "color",
            "light",
            "neutral",
            "99"
          ]
        },
        "100": {
          "value": "#ffffff",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#FFFFFF"
          },
          "name": "ColorLightNeutral100",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "neutral",
            "subitem": "100"
          },
          "path": [
            "color",
            "light",
            "neutral",
            "100"
          ]
        },
        "background": {
          "value": "#ffffff",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.neutral.100}"
          },
          "name": "ColorLightNeutralBackground",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "neutral",
            "subitem": "background"
          },
          "path": [
            "color",
            "light",
            "neutral",
            "background"
          ]
        },
        "surface": {
          "value": "#f6f6f6",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.neutral.99}"
          },
          "name": "ColorLightNeutralSurface",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "neutral",
            "subitem": "surface"
          },
          "path": [
            "color",
            "light",
            "neutral",
            "surface"
          ]
        },
        "surface-disabled": {
          "value": "#e7e7e7",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.neutral.95}"
          },
          "name": "ColorLightNeutralSurfaceDisabled",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "neutral",
            "subitem": "surface-disabled"
          },
          "path": [
            "color",
            "light",
            "neutral",
            "surface-disabled"
          ]
        },
        "surface-highlight": {
          "value": "#d1d1d1",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.neutral.90}"
          },
          "name": "ColorLightNeutralSurfaceHighlight",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "neutral",
            "subitem": "surface-highlight"
          },
          "path": [
            "color",
            "light",
            "neutral",
            "surface-highlight"
          ]
        },
        "interactive": {
          "value": "#b0b0b0",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.neutral.80}"
          },
          "name": "ColorLightNeutralInteractive",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "neutral",
            "subitem": "interactive"
          },
          "path": [
            "color",
            "light",
            "neutral",
            "interactive"
          ]
        },
        "interactive-hover": {
          "value": "#888888",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.neutral.70}"
          },
          "name": "ColorLightNeutralInteractiveHover",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "neutral",
            "subitem": "interactive-hover"
          },
          "path": [
            "color",
            "light",
            "neutral",
            "interactive-hover"
          ]
        },
        "interactive-pressed": {
          "value": "#777777",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.neutral.60}"
          },
          "name": "ColorLightNeutralInteractivePressed",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "neutral",
            "subitem": "interactive-pressed"
          },
          "path": [
            "color",
            "light",
            "neutral",
            "interactive-pressed"
          ]
        },
        "text-disabled": {
          "value": "#6d6d6d",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.neutral.50}"
          },
          "name": "ColorLightNeutralTextDisabled",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "neutral",
            "subitem": "text-disabled"
          },
          "path": [
            "color",
            "light",
            "neutral",
            "text-disabled"
          ]
        },
        "text-low": {
          "value": "#5d5d5d",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.neutral.40}"
          },
          "name": "ColorLightNeutralTextLow",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "neutral",
            "subitem": "text-low"
          },
          "path": [
            "color",
            "light",
            "neutral",
            "text-low"
          ]
        },
        "text-high": {
          "value": "#0a0a0a",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.neutral.0}"
          },
          "name": "ColorLightNeutralTextHigh",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "neutral",
            "subitem": "text-high"
          },
          "path": [
            "color",
            "light",
            "neutral",
            "text-high"
          ]
        }
      },
      "next": {
        "5": {
          "value": "#000519",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#000519"
          },
          "name": "ColorLightNext5",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "next",
            "subitem": "5"
          },
          "path": [
            "color",
            "light",
            "next",
            "5"
          ]
        },
        "10": {
          "value": "#22242f",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#22242F"
          },
          "name": "ColorLightNext10",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "next",
            "subitem": "10"
          },
          "path": [
            "color",
            "light",
            "next",
            "10"
          ]
        },
        "20": {
          "value": "#343746",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#343746"
          },
          "name": "ColorLightNext20",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "next",
            "subitem": "20"
          },
          "path": [
            "color",
            "light",
            "next",
            "20"
          ]
        },
        "30": {
          "value": "#3b4053",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#3B4053"
          },
          "name": "ColorLightNext30",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "next",
            "subitem": "30"
          },
          "path": [
            "color",
            "light",
            "next",
            "30"
          ]
        },
        "40": {
          "value": "#3f445a",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#3F445A"
          },
          "name": "ColorLightNext40",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "next",
            "subitem": "40"
          },
          "path": [
            "color",
            "light",
            "next",
            "40"
          ]
        },
        "50": {
          "value": "#434961",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#434961"
          },
          "name": "ColorLightNext50",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "next",
            "subitem": "50"
          },
          "path": [
            "color",
            "light",
            "next",
            "50"
          ]
        },
        "60": {
          "value": "#555c74",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#555C74"
          },
          "name": "ColorLightNext60",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "next",
            "subitem": "60"
          },
          "path": [
            "color",
            "light",
            "next",
            "60"
          ]
        },
        "70": {
          "value": "#777b8c",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#777B8C"
          },
          "name": "ColorLightNext70",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "next",
            "subitem": "70"
          },
          "path": [
            "color",
            "light",
            "next",
            "70"
          ]
        },
        "80": {
          "value": "#8e93a2",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#8E93A2"
          },
          "name": "ColorLightNext80",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "next",
            "subitem": "80"
          },
          "path": [
            "color",
            "light",
            "next",
            "80"
          ]
        },
        "90": {
          "value": "#b2b5c6",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#B2B5C6"
          },
          "name": "ColorLightNext90",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "next",
            "subitem": "90"
          },
          "path": [
            "color",
            "light",
            "next",
            "90"
          ]
        },
        "95": {
          "value": "#d5d7e2",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#D5D7E2"
          },
          "name": "ColorLightNext95",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "next",
            "subitem": "95"
          },
          "path": [
            "color",
            "light",
            "next",
            "95"
          ]
        },
        "99": {
          "value": "#edf0ff",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#EDF0FF"
          },
          "name": "ColorLightNext99",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "next",
            "subitem": "99"
          },
          "path": [
            "color",
            "light",
            "next",
            "99"
          ]
        },
        "100": {
          "value": "#ffffff",
          "filePath": "src/color/ref.json",
          "isSource": true,
          "original": {
            "value": "#FFFFFF"
          },
          "name": "ColorLightNext100",
          "attributes": {
            "category": "color",
            "type": "light",
            "item": "next",
            "subitem": "100"
          },
          "path": [
            "color",
            "light",
            "next",
            "100"
          ]
        }
      }
    },
    "dark": {
      "primary": {
        "surface": {
          "value": "#001737",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.primary.10}"
          },
          "name": "ColorDarkPrimarySurface",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "primary",
            "subitem": "surface"
          },
          "path": [
            "color",
            "dark",
            "primary",
            "surface"
          ]
        },
        "surface-highlight": {
          "value": "#00347d",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.primary.30}"
          },
          "name": "ColorDarkPrimarySurfaceHighlight",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "primary",
            "subitem": "surface-highlight"
          },
          "path": [
            "color",
            "dark",
            "primary",
            "surface-highlight"
          ]
        },
        "interactive": {
          "value": "#2577e9",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.primary.70}"
          },
          "name": "ColorDarkPrimaryInteractive",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "primary",
            "subitem": "interactive"
          },
          "path": [
            "color",
            "dark",
            "primary",
            "interactive"
          ]
        },
        "interactive-hover": {
          "value": "#4b92f5",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.primary.80}"
          },
          "name": "ColorDarkPrimaryInteractiveHover",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "primary",
            "subitem": "interactive-hover"
          },
          "path": [
            "color",
            "dark",
            "primary",
            "interactive-hover"
          ]
        },
        "interactive-pressed": {
          "value": "#96c1fc",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.primary.90}"
          },
          "name": "ColorDarkPrimaryInteractivePressed",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "primary",
            "subitem": "interactive-pressed"
          },
          "path": [
            "color",
            "dark",
            "primary",
            "interactive-pressed"
          ]
        },
        "text-low": {
          "value": "#c2dbfe",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.primary.95}"
          },
          "name": "ColorDarkPrimaryTextLow",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "primary",
            "subitem": "text-low"
          },
          "path": [
            "color",
            "dark",
            "primary",
            "text-low"
          ]
        },
        "text-high": {
          "value": "#ffffff",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.primary.100}"
          },
          "name": "ColorDarkPrimaryTextHigh",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "primary",
            "subitem": "text-high"
          },
          "path": [
            "color",
            "dark",
            "primary",
            "text-high"
          ]
        }
      },
      "success": {
        "surface": {
          "value": "#003420",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.success.10}"
          },
          "name": "ColorDarkSuccessSurface",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "success",
            "subitem": "surface"
          },
          "path": [
            "color",
            "dark",
            "success",
            "surface"
          ]
        },
        "surface-highlight": {
          "value": "#007447",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.success.30}"
          },
          "name": "ColorDarkSuccessSurfaceHighlight",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "success",
            "subitem": "surface-highlight"
          },
          "path": [
            "color",
            "dark",
            "success",
            "surface-highlight"
          ]
        },
        "interactive": {
          "value": "#0fdc8e",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.success.70}"
          },
          "name": "ColorDarkSuccessInteractive",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "success",
            "subitem": "interactive"
          },
          "path": [
            "color",
            "dark",
            "success",
            "interactive"
          ]
        },
        "interactive-hover": {
          "value": "#3feca9",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.success.80}"
          },
          "name": "ColorDarkSuccessInteractiveHover",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "success",
            "subitem": "interactive-hover"
          },
          "path": [
            "color",
            "dark",
            "success",
            "interactive-hover"
          ]
        },
        "interactive-pressed": {
          "value": "#7af7c7",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.success.90}"
          },
          "name": "ColorDarkSuccessInteractivePressed",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "success",
            "subitem": "interactive-pressed"
          },
          "path": [
            "color",
            "dark",
            "success",
            "interactive-pressed"
          ]
        },
        "text-low": {
          "value": "#bcfde4",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.success.95}"
          },
          "name": "ColorDarkSuccessTextLow",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "success",
            "subitem": "text-low"
          },
          "path": [
            "color",
            "dark",
            "success",
            "text-low"
          ]
        },
        "text-high": {
          "value": "#ffffff",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.success.100}"
          },
          "name": "ColorDarkSuccessTextHigh",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "success",
            "subitem": "text-high"
          },
          "path": [
            "color",
            "dark",
            "success",
            "text-high"
          ]
        }
      },
      "warning": {
        "surface": {
          "value": "#342000",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.warning.10}"
          },
          "name": "ColorDarkWarningSurface",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "warning",
            "subitem": "surface"
          },
          "path": [
            "color",
            "dark",
            "warning",
            "surface"
          ]
        },
        "surface-highlight": {
          "value": "#744700",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.warning.30}"
          },
          "name": "ColorDarkWarningSurfaceHighlight",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "warning",
            "subitem": "surface-highlight"
          },
          "path": [
            "color",
            "dark",
            "warning",
            "surface-highlight"
          ]
        },
        "interactive": {
          "value": "#dc8e0f",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.warning.70}"
          },
          "name": "ColorDarkWarningInteractive",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "warning",
            "subitem": "interactive"
          },
          "path": [
            "color",
            "dark",
            "warning",
            "interactive"
          ]
        },
        "interactive-hover": {
          "value": "#eca93f",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.warning.80}"
          },
          "name": "ColorDarkWarningInteractiveHover",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "warning",
            "subitem": "interactive-hover"
          },
          "path": [
            "color",
            "dark",
            "warning",
            "interactive-hover"
          ]
        },
        "interactive-pressed": {
          "value": "#f7c77a",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.warning.90}"
          },
          "name": "ColorDarkWarningInteractivePressed",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "warning",
            "subitem": "interactive-pressed"
          },
          "path": [
            "color",
            "dark",
            "warning",
            "interactive-pressed"
          ]
        },
        "text-low": {
          "value": "#fde4bc",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.warning.95}"
          },
          "name": "ColorDarkWarningTextLow",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "warning",
            "subitem": "text-low"
          },
          "path": [
            "color",
            "dark",
            "warning",
            "text-low"
          ]
        },
        "text-high": {
          "value": "#ffffff",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.warning.100}"
          },
          "name": "ColorDarkWarningTextHigh",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "warning",
            "subitem": "text-high"
          },
          "path": [
            "color",
            "dark",
            "warning",
            "text-high"
          ]
        }
      },
      "danger": {
        "surface": {
          "value": "#340001",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.danger.10}"
          },
          "name": "ColorDarkDangerSurface",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "danger",
            "subitem": "surface"
          },
          "path": [
            "color",
            "dark",
            "danger",
            "surface"
          ]
        },
        "surface-highlight": {
          "value": "#740002",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.danger.30}"
          },
          "name": "ColorDarkDangerSurfaceHighlight",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "danger",
            "subitem": "surface-highlight"
          },
          "path": [
            "color",
            "dark",
            "danger",
            "surface-highlight"
          ]
        },
        "interactive": {
          "value": "#dc0f13",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.danger.70}"
          },
          "name": "ColorDarkDangerInteractive",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "danger",
            "subitem": "interactive"
          },
          "path": [
            "color",
            "dark",
            "danger",
            "interactive"
          ]
        },
        "interactive-hover": {
          "value": "#ec3f41",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.danger.80}"
          },
          "name": "ColorDarkDangerInteractiveHover",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "danger",
            "subitem": "interactive-hover"
          },
          "path": [
            "color",
            "dark",
            "danger",
            "interactive-hover"
          ]
        },
        "interactive-pressed": {
          "value": "#f77a7c",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.danger.90}"
          },
          "name": "ColorDarkDangerInteractivePressed",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "danger",
            "subitem": "interactive-pressed"
          },
          "path": [
            "color",
            "dark",
            "danger",
            "interactive-pressed"
          ]
        },
        "text-low": {
          "value": "#fdbcbd",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.danger.95}"
          },
          "name": "ColorDarkDangerTextLow",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "danger",
            "subitem": "text-low"
          },
          "path": [
            "color",
            "dark",
            "danger",
            "text-low"
          ]
        },
        "text-high": {
          "value": "#ffffff",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.danger.100}"
          },
          "name": "ColorDarkDangerTextHigh",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "danger",
            "subitem": "text-high"
          },
          "path": [
            "color",
            "dark",
            "danger",
            "text-high"
          ]
        }
      },
      "neutral": {
        "background": {
          "value": "#0a0a0a",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.neutral.0}"
          },
          "name": "ColorDarkNeutralBackground",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "neutral",
            "subitem": "background"
          },
          "path": [
            "color",
            "dark",
            "neutral",
            "background"
          ]
        },
        "surface": {
          "value": "#1f2020",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.neutral.5}"
          },
          "name": "ColorDarkNeutralSurface",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "neutral",
            "subitem": "surface"
          },
          "path": [
            "color",
            "dark",
            "neutral",
            "surface"
          ]
        },
        "surface-disabled": {
          "value": "#3d3d3d",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.neutral.10}"
          },
          "name": "ColorDarkNeutralSurfaceDisabled",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "neutral",
            "subitem": "surface-disabled"
          },
          "path": [
            "color",
            "dark",
            "neutral",
            "surface-disabled"
          ]
        },
        "surface-highlight": {
          "value": "#454545",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.neutral.20}"
          },
          "name": "ColorDarkNeutralSurfaceHighlight",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "neutral",
            "subitem": "surface-highlight"
          },
          "path": [
            "color",
            "dark",
            "neutral",
            "surface-highlight"
          ]
        },
        "interactive": {
          "value": "#4f4f4f",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.neutral.30}"
          },
          "name": "ColorDarkNeutralInteractive",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "neutral",
            "subitem": "interactive"
          },
          "path": [
            "color",
            "dark",
            "neutral",
            "interactive"
          ]
        },
        "interactive-hover": {
          "value": "#5d5d5d",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.neutral.40}"
          },
          "name": "ColorDarkNeutralInteractiveHover",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "neutral",
            "subitem": "interactive-hover"
          },
          "path": [
            "color",
            "dark",
            "neutral",
            "interactive-hover"
          ]
        },
        "interactive-pressed": {
          "value": "#6d6d6d",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.neutral.50}"
          },
          "name": "ColorDarkNeutralInteractivePressed",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "neutral",
            "subitem": "interactive-pressed"
          },
          "path": [
            "color",
            "dark",
            "neutral",
            "interactive-pressed"
          ]
        },
        "text-disabled": {
          "value": "#777777",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.neutral.60}"
          },
          "name": "ColorDarkNeutralTextDisabled",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "neutral",
            "subitem": "text-disabled"
          },
          "path": [
            "color",
            "dark",
            "neutral",
            "text-disabled"
          ]
        },
        "text-low": {
          "value": "#888888",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.neutral.70}"
          },
          "name": "ColorDarkNeutralTextLow",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "neutral",
            "subitem": "text-low"
          },
          "path": [
            "color",
            "dark",
            "neutral",
            "text-low"
          ]
        },
        "text-high": {
          "value": "#ffffff",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.neutral.100}"
          },
          "name": "ColorDarkNeutralTextHigh",
          "attributes": {
            "category": "color",
            "type": "dark",
            "item": "neutral",
            "subitem": "text-high"
          },
          "path": [
            "color",
            "dark",
            "neutral",
            "text-high"
          ]
        }
      }
    },
    "next": {
      "primary": {
        "surface": {
          "value": "#edf0ff",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.next.99}"
          },
          "name": "ColorNextPrimarySurface",
          "attributes": {
            "category": "color",
            "type": "next",
            "item": "primary",
            "subitem": "surface"
          },
          "path": [
            "color",
            "next",
            "primary",
            "surface"
          ]
        },
        "surface-highlight": {
          "value": "#b2b5c6",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.next.90}"
          },
          "name": "ColorNextPrimarySurfaceHighlight",
          "attributes": {
            "category": "color",
            "type": "next",
            "item": "primary",
            "subitem": "surface-highlight"
          },
          "path": [
            "color",
            "next",
            "primary",
            "surface-highlight"
          ]
        },
        "interactive": {
          "value": "#555c74",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.next.60}"
          },
          "name": "ColorNextPrimaryInteractive",
          "attributes": {
            "category": "color",
            "type": "next",
            "item": "primary",
            "subitem": "interactive"
          },
          "path": [
            "color",
            "next",
            "primary",
            "interactive"
          ]
        },
        "interactive-hover": {
          "value": "#3f445a",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.next.40}"
          },
          "name": "ColorNextPrimaryInteractiveHover",
          "attributes": {
            "category": "color",
            "type": "next",
            "item": "primary",
            "subitem": "interactive-hover"
          },
          "path": [
            "color",
            "next",
            "primary",
            "interactive-hover"
          ]
        },
        "interactive-pressed": {
          "value": "#3b4053",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.next.30}"
          },
          "name": "ColorNextPrimaryInteractivePressed",
          "attributes": {
            "category": "color",
            "type": "next",
            "item": "primary",
            "subitem": "interactive-pressed"
          },
          "path": [
            "color",
            "next",
            "primary",
            "interactive-pressed"
          ]
        },
        "text-low": {
          "value": "#343746",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.next.20}"
          },
          "name": "ColorNextPrimaryTextLow",
          "attributes": {
            "category": "color",
            "type": "next",
            "item": "primary",
            "subitem": "text-low"
          },
          "path": [
            "color",
            "next",
            "primary",
            "text-low"
          ]
        },
        "text-high": {
          "value": "#000519",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.next.5}"
          },
          "name": "ColorNextPrimaryTextHigh",
          "attributes": {
            "category": "color",
            "type": "next",
            "item": "primary",
            "subitem": "text-high"
          },
          "path": [
            "color",
            "next",
            "primary",
            "text-high"
          ]
        }
      }
    },
    "next-dark": {
      "primary": {
        "surface": {
          "value": "#22242f",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.next.10}"
          },
          "name": "ColorNextDarkPrimarySurface",
          "attributes": {
            "category": "color",
            "type": "next-dark",
            "item": "primary",
            "subitem": "surface"
          },
          "path": [
            "color",
            "next-dark",
            "primary",
            "surface"
          ]
        },
        "surface-highlight": {
          "value": "#3b4053",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.next.30}"
          },
          "name": "ColorNextDarkPrimarySurfaceHighlight",
          "attributes": {
            "category": "color",
            "type": "next-dark",
            "item": "primary",
            "subitem": "surface-highlight"
          },
          "path": [
            "color",
            "next-dark",
            "primary",
            "surface-highlight"
          ]
        },
        "interactive": {
          "value": "#777b8c",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.next.70}"
          },
          "name": "ColorNextDarkPrimaryInteractive",
          "attributes": {
            "category": "color",
            "type": "next-dark",
            "item": "primary",
            "subitem": "interactive"
          },
          "path": [
            "color",
            "next-dark",
            "primary",
            "interactive"
          ]
        },
        "interactive-hover": {
          "value": "#8e93a2",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.next.80}"
          },
          "name": "ColorNextDarkPrimaryInteractiveHover",
          "attributes": {
            "category": "color",
            "type": "next-dark",
            "item": "primary",
            "subitem": "interactive-hover"
          },
          "path": [
            "color",
            "next-dark",
            "primary",
            "interactive-hover"
          ]
        },
        "interactive-pressed": {
          "value": "#b2b5c6",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.next.90}"
          },
          "name": "ColorNextDarkPrimaryInteractivePressed",
          "attributes": {
            "category": "color",
            "type": "next-dark",
            "item": "primary",
            "subitem": "interactive-pressed"
          },
          "path": [
            "color",
            "next-dark",
            "primary",
            "interactive-pressed"
          ]
        },
        "text-low": {
          "value": "#d5d7e2",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.next.95}"
          },
          "name": "ColorNextDarkPrimaryTextLow",
          "attributes": {
            "category": "color",
            "type": "next-dark",
            "item": "primary",
            "subitem": "text-low"
          },
          "path": [
            "color",
            "next-dark",
            "primary",
            "text-low"
          ]
        },
        "text-high": {
          "value": "#ffffff",
          "filePath": "src/color/sys.json",
          "isSource": true,
          "original": {
            "value": "{color.light.next.100}"
          },
          "name": "ColorNextDarkPrimaryTextHigh",
          "attributes": {
            "category": "color",
            "type": "next-dark",
            "item": "primary",
            "subitem": "text-high"
          },
          "path": [
            "color",
            "next-dark",
            "primary",
            "text-high"
          ]
        }
      }
    }
  },
  "motion": {
    "speed": {
      "fast": {
        "value": "150ms",
        "filePath": "src/motion/sys.json",
        "isSource": true,
        "original": {
          "value": "150ms"
        },
        "name": "MotionSpeedFast",
        "attributes": {
          "category": "motion",
          "type": "speed",
          "item": "fast"
        },
        "path": [
          "motion",
          "speed",
          "fast"
        ]
      },
      "base": {
        "value": "300ms",
        "filePath": "src/motion/sys.json",
        "isSource": true,
        "original": {
          "value": "300ms"
        },
        "name": "MotionSpeedBase",
        "attributes": {
          "category": "motion",
          "type": "speed",
          "item": "base"
        },
        "path": [
          "motion",
          "speed",
          "base"
        ]
      },
      "slow": {
        "value": "450ms",
        "filePath": "src/motion/sys.json",
        "isSource": true,
        "original": {
          "value": "450ms"
        },
        "name": "MotionSpeedSlow",
        "attributes": {
          "category": "motion",
          "type": "speed",
          "item": "slow"
        },
        "path": [
          "motion",
          "speed",
          "slow"
        ]
      },
      "slower": {
        "value": "600ms",
        "filePath": "src/motion/sys.json",
        "isSource": true,
        "original": {
          "value": "600ms"
        },
        "name": "MotionSpeedSlower",
        "attributes": {
          "category": "motion",
          "type": "speed",
          "item": "slower"
        },
        "path": [
          "motion",
          "speed",
          "slower"
        ]
      }
    }
  },
  "shadow": {
    "level": {
      "0": {
        "value": "none",
        "filePath": "src/shadow/ref.json",
        "isSource": true,
        "original": {
          "value": "none"
        },
        "name": "ShadowLevel0",
        "attributes": {
          "category": "shadow",
          "type": "level",
          "item": "0"
        },
        "path": [
          "shadow",
          "level",
          "0"
        ]
      },
      "1": {
        "value": "0px 0px 1px 0px #888888",
        "filePath": "src/shadow/ref.json",
        "isSource": true,
        "original": {
          "value": "0px 0px 1px 0px {color.light.neutral.interactive-hover}"
        },
        "name": "ShadowLevel1",
        "attributes": {
          "category": "shadow",
          "type": "level",
          "item": "1"
        },
        "path": [
          "shadow",
          "level",
          "1"
        ]
      },
      "2": {
        "value": "0px 0px 2px 0px #888888",
        "filePath": "src/shadow/ref.json",
        "isSource": true,
        "original": {
          "value": "0px 0px 2px 0px {color.light.neutral.interactive-hover}"
        },
        "name": "ShadowLevel2",
        "attributes": {
          "category": "shadow",
          "type": "level",
          "item": "2"
        },
        "path": [
          "shadow",
          "level",
          "2"
        ]
      },
      "3": {
        "value": "0px 3px 6px 0px #d1d1d1, 0px 0px 1px 0px #888888",
        "filePath": "src/shadow/ref.json",
        "isSource": true,
        "original": {
          "value": "0px 3px 6px 0px {color.light.neutral.surface-highlight}, 0px 0px 1px 0px {color.light.neutral.interactive-hover}"
        },
        "name": "ShadowLevel3",
        "attributes": {
          "category": "shadow",
          "type": "level",
          "item": "3"
        },
        "path": [
          "shadow",
          "level",
          "3"
        ]
      },
      "4": {
        "value": "0px 12px 16px 0px #d1d1d1, 0px 0px 1px 0px #888888",
        "filePath": "src/shadow/ref.json",
        "isSource": true,
        "original": {
          "value": "0px 12px 16px 0px {color.light.neutral.surface-highlight}, 0px 0px 1px 0px {color.light.neutral.interactive-hover}"
        },
        "name": "ShadowLevel4",
        "attributes": {
          "category": "shadow",
          "type": "level",
          "item": "4"
        },
        "path": [
          "shadow",
          "level",
          "4"
        ]
      },
      "5": {
        "value": "0px 24px 32px 0px #d1d1d1, 0px 0px 1px 0px #888888",
        "filePath": "src/shadow/ref.json",
        "isSource": true,
        "original": {
          "value": "0px 24px 32px 0px {color.light.neutral.surface-highlight}, 0px 0px 1px 0px {color.light.neutral.interactive-hover}"
        },
        "name": "ShadowLevel5",
        "attributes": {
          "category": "shadow",
          "type": "level",
          "item": "5"
        },
        "path": [
          "shadow",
          "level",
          "5"
        ]
      }
    },
    "light": {
      "level": {
        "0": {
          "value": "none",
          "comment": "Inicial level without shadow. Used for background or elements that do not need to be distinguished from the background.",
          "filePath": "src/shadow/sys.json",
          "isSource": true,
          "original": {
            "value": "{shadow.level.0}",
            "comment": "Inicial level without shadow. Used for background or elements that do not need to be distinguished from the background."
          },
          "name": "ShadowLightLevel0",
          "attributes": {
            "category": "shadow",
            "type": "light",
            "item": "level",
            "subitem": "0"
          },
          "path": [
            "shadow",
            "light",
            "level",
            "0"
          ]
        },
        "1": {
          "value": "0px 0px 1px 0px #888888",
          "comment": "Shadow level for elements that are floating at minimal distance from the background. Can be used in interactive elements.",
          "filePath": "src/shadow/sys.json",
          "isSource": true,
          "original": {
            "value": "{shadow.level.1}",
            "comment": "Shadow level for elements that are floating at minimal distance from the background. Can be used in interactive elements."
          },
          "name": "ShadowLightLevel1",
          "attributes": {
            "category": "shadow",
            "type": "light",
            "item": "level",
            "subitem": "1"
          },
          "path": [
            "shadow",
            "light",
            "level",
            "1"
          ]
        },
        "2": {
          "value": "0px 0px 2px 0px #888888",
          "comment": "Shadow level for elements that are floating at small distance from the background. Can be used in cards.",
          "filePath": "src/shadow/sys.json",
          "isSource": true,
          "original": {
            "value": "{shadow.level.2}",
            "comment": "Shadow level for elements that are floating at small distance from the background. Can be used in cards."
          },
          "name": "ShadowLightLevel2",
          "attributes": {
            "category": "shadow",
            "type": "light",
            "item": "level",
            "subitem": "2"
          },
          "path": [
            "shadow",
            "light",
            "level",
            "2"
          ]
        },
        "3": {
          "value": "0px 3px 6px 0px #d1d1d1, 0px 0px 1px 0px #888888",
          "comment": "Shadow level for elements that are floating at medium distance from the background. Can be used in popovers.",
          "filePath": "src/shadow/sys.json",
          "isSource": true,
          "original": {
            "value": "{shadow.level.3}",
            "comment": "Shadow level for elements that are floating at medium distance from the background. Can be used in popovers."
          },
          "name": "ShadowLightLevel3",
          "attributes": {
            "category": "shadow",
            "type": "light",
            "item": "level",
            "subitem": "3"
          },
          "path": [
            "shadow",
            "light",
            "level",
            "3"
          ]
        },
        "4": {
          "value": "0px 12px 16px 0px #d1d1d1, 0px 0px 1px 0px #888888",
          "comment": "Shadow for elements that are floating at a large distance from the background. Can be used in modals.",
          "filePath": "src/shadow/sys.json",
          "isSource": true,
          "original": {
            "value": "{shadow.level.4}",
            "comment": "Shadow for elements that are floating at a large distance from the background. Can be used in modals."
          },
          "name": "ShadowLightLevel4",
          "attributes": {
            "category": "shadow",
            "type": "light",
            "item": "level",
            "subitem": "4"
          },
          "path": [
            "shadow",
            "light",
            "level",
            "4"
          ]
        },
        "5": {
          "value": "0px 24px 32px 0px #d1d1d1, 0px 0px 1px 0px #888888",
          "comment": "Shadow level for elements that are floating at maximum distance from the background. Can be used in side modals.",
          "filePath": "src/shadow/sys.json",
          "isSource": true,
          "original": {
            "value": "{shadow.level.5}",
            "comment": "Shadow level for elements that are floating at maximum distance from the background. Can be used in side modals."
          },
          "name": "ShadowLightLevel5",
          "attributes": {
            "category": "shadow",
            "type": "light",
            "item": "level",
            "subitem": "5"
          },
          "path": [
            "shadow",
            "light",
            "level",
            "5"
          ]
        }
      }
    },
    "dark": {
      "level": {
        "0": {
          "value": "none",
          "comment": "Inicial level without shadow. Used for background or elements that do not need to be distinguished from the background.",
          "filePath": "src/shadow/sys.json",
          "isSource": true,
          "original": {
            "value": "none",
            "comment": "Inicial level without shadow. Used for background or elements that do not need to be distinguished from the background."
          },
          "name": "ShadowDarkLevel0",
          "attributes": {
            "category": "shadow",
            "type": "dark",
            "item": "level",
            "subitem": "0"
          },
          "path": [
            "shadow",
            "dark",
            "level",
            "0"
          ]
        },
        "1": {
          "value": "0px 0px 1px 0px #5d5d5d",
          "comment": "Shadow level for elements that are floating at minimal distance from the background. Can be used in interactive elements.",
          "filePath": "src/shadow/sys.json",
          "isSource": true,
          "original": {
            "value": "0px 0px 1px 0px {color.dark.neutral.interactive-hover}",
            "comment": "Shadow level for elements that are floating at minimal distance from the background. Can be used in interactive elements."
          },
          "name": "ShadowDarkLevel1",
          "attributes": {
            "category": "shadow",
            "type": "dark",
            "item": "level",
            "subitem": "1"
          },
          "path": [
            "shadow",
            "dark",
            "level",
            "1"
          ]
        },
        "2": {
          "value": "0px 0px 2px 0px #5d5d5d",
          "comment": "Shadow level for elements that are floating at small distance from the background. Can be used in cards.",
          "filePath": "src/shadow/sys.json",
          "isSource": true,
          "original": {
            "value": "0px 0px 2px 0px {color.dark.neutral.interactive-hover}",
            "comment": "Shadow level for elements that are floating at small distance from the background. Can be used in cards."
          },
          "name": "ShadowDarkLevel2",
          "attributes": {
            "category": "shadow",
            "type": "dark",
            "item": "level",
            "subitem": "2"
          },
          "path": [
            "shadow",
            "dark",
            "level",
            "2"
          ]
        },
        "3": {
          "value": "0px 3px 6px 0px #454545, 0px 0px 1px 0px #5d5d5d",
          "comment": "Shadow level for elements that are floating at medium distance from the background. Can be used in popovers.",
          "filePath": "src/shadow/sys.json",
          "isSource": true,
          "original": {
            "value": "0px 3px 6px 0px {color.dark.neutral.surface-highlight}, 0px 0px 1px 0px {color.dark.neutral.interactive-hover}",
            "comment": "Shadow level for elements that are floating at medium distance from the background. Can be used in popovers."
          },
          "name": "ShadowDarkLevel3",
          "attributes": {
            "category": "shadow",
            "type": "dark",
            "item": "level",
            "subitem": "3"
          },
          "path": [
            "shadow",
            "dark",
            "level",
            "3"
          ]
        },
        "4": {
          "value": "0px 12px 16px 0px #454545, 0px 0px 1px 0px #5d5d5d",
          "comment": "Shadow for elements that are floating at a large distance from the background. Can be used in modals.",
          "filePath": "src/shadow/sys.json",
          "isSource": true,
          "original": {
            "value": "0px 12px 16px 0px {color.dark.neutral.surface-highlight}, 0px 0px 1px 0px {color.dark.neutral.interactive-hover}",
            "comment": "Shadow for elements that are floating at a large distance from the background. Can be used in modals."
          },
          "name": "ShadowDarkLevel4",
          "attributes": {
            "category": "shadow",
            "type": "dark",
            "item": "level",
            "subitem": "4"
          },
          "path": [
            "shadow",
            "dark",
            "level",
            "4"
          ]
        },
        "5": {
          "value": "0px 24px 32px 0px #454545, 0px 0px 1px 0px #5d5d5d",
          "comment": "Shadow level for elements that are floating at maximum distance from the background. Can be used in side modals.",
          "filePath": "src/shadow/sys.json",
          "isSource": true,
          "original": {
            "value": "0px 24px 32px 0px {color.dark.neutral.surface-highlight}, 0px 0px 1px 0px {color.dark.neutral.interactive-hover}",
            "comment": "Shadow level for elements that are floating at maximum distance from the background. Can be used in side modals."
          },
          "name": "ShadowDarkLevel5",
          "attributes": {
            "category": "shadow",
            "type": "dark",
            "item": "level",
            "subitem": "5"
          },
          "path": [
            "shadow",
            "dark",
            "level",
            "5"
          ]
        }
      }
    }
  },
  "shape": {
    "border": {
      "radius": {
        "1": {
          "value": "0.25rem",
          "comment": "It can be used in medium or small elements with or without interactions.",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "{spacing.1}",
            "comment": "It can be used in medium or small elements with or without interactions."
          },
          "name": "ShapeBorderRadius1",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "radius",
            "subitem": "1"
          },
          "path": [
            "shape",
            "border",
            "radius",
            "1"
          ]
        },
        "2": {
          "value": "0.5rem",
          "comment": "It can be used on medium or large elements with or without interactions.",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "{spacing.2}",
            "comment": "It can be used on medium or large elements with or without interactions."
          },
          "name": "ShapeBorderRadius2",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "radius",
            "subitem": "2"
          },
          "path": [
            "shape",
            "border",
            "radius",
            "2"
          ]
        },
        "3": {
          "value": "0.75rem",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "{spacing.3}"
          },
          "name": "ShapeBorderRadius3",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "radius",
            "subitem": "3"
          },
          "path": [
            "shape",
            "border",
            "radius",
            "3"
          ]
        },
        "4": {
          "value": "1rem",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "{spacing.4}"
          },
          "name": "ShapeBorderRadius4",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "radius",
            "subitem": "4"
          },
          "path": [
            "shape",
            "border",
            "radius",
            "4"
          ]
        },
        "5": {
          "value": "1.25rem",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "{spacing.5}"
          },
          "name": "ShapeBorderRadius5",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "radius",
            "subitem": "5"
          },
          "path": [
            "shape",
            "border",
            "radius",
            "5"
          ]
        },
        "6": {
          "value": "1.5rem",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "{spacing.6}"
          },
          "name": "ShapeBorderRadius6",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "radius",
            "subitem": "6"
          },
          "path": [
            "shape",
            "border",
            "radius",
            "6"
          ]
        },
        "0-5": {
          "value": "0.125rem",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "{spacing.0-5}"
          },
          "name": "ShapeBorderRadius05",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "radius",
            "subitem": "0-5"
          },
          "path": [
            "shape",
            "border",
            "radius",
            "0-5"
          ]
        },
        "full": {
          "value": "9999px",
          "comment": "It can be used in small or fully rounded elements with or without interactions.",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "9999px",
            "comment": "It can be used in small or fully rounded elements with or without interactions."
          },
          "name": "ShapeBorderRadiusFull",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "radius",
            "subitem": "full"
          },
          "path": [
            "shape",
            "border",
            "radius",
            "full"
          ]
        },
        "base": {
          "value": "0.375rem",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "{spacing.1-5}"
          },
          "name": "ShapeBorderRadiusBase",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "radius",
            "subitem": "base"
          },
          "path": [
            "shape",
            "border",
            "radius",
            "base"
          ]
        },
        "half": {
          "value": "50%",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "50%"
          },
          "name": "ShapeBorderRadiusHalf",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "radius",
            "subitem": "half"
          },
          "path": [
            "shape",
            "border",
            "radius",
            "half"
          ]
        }
      },
      "width": {
        "1": {
          "value": "0.0625rem",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "0.0625rem"
          },
          "name": "ShapeBorderWidth1",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "width",
            "subitem": "1"
          },
          "path": [
            "shape",
            "border",
            "width",
            "1"
          ]
        },
        "2": {
          "value": "0.125rem",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "0.125rem"
          },
          "name": "ShapeBorderWidth2",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "width",
            "subitem": "2"
          },
          "path": [
            "shape",
            "border",
            "width",
            "2"
          ]
        },
        "3": {
          "value": "0.1875rem",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "0.1875rem"
          },
          "name": "ShapeBorderWidth3",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "width",
            "subitem": "3"
          },
          "path": [
            "shape",
            "border",
            "width",
            "3"
          ]
        },
        "4": {
          "value": "1rem",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "1rem"
          },
          "name": "ShapeBorderWidth4",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "width",
            "subitem": "4"
          },
          "path": [
            "shape",
            "border",
            "width",
            "4"
          ]
        },
        "5": {
          "value": "1.25rem",
          "filePath": "src/shape/sys.json",
          "isSource": true,
          "original": {
            "value": "1.25rem"
          },
          "name": "ShapeBorderWidth5",
          "attributes": {
            "category": "shape",
            "type": "border",
            "item": "width",
            "subitem": "5"
          },
          "path": [
            "shape",
            "border",
            "width",
            "5"
          ]
        }
      }
    }
  },
  "spacing": {
    "1": {
      "value": "0.25rem",
      "comment": "Internal spaces in atomic components such as buttons or links.",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "0.25rem",
        "comment": "Internal spaces in atomic components such as buttons or links."
      },
      "name": "Spacing1",
      "attributes": {
        "category": "spacing",
        "type": "1"
      },
      "path": [
        "spacing",
        "1"
      ]
    },
    "2": {
      "value": "0.5rem",
      "comment": "Separation of elements within a container or component padding.",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "0.5rem",
        "comment": "Separation of elements within a container or component padding."
      },
      "name": "Spacing2",
      "attributes": {
        "category": "spacing",
        "type": "2"
      },
      "path": [
        "spacing",
        "2"
      ]
    },
    "3": {
      "value": "0.75rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "0.75rem"
      },
      "name": "Spacing3",
      "attributes": {
        "category": "spacing",
        "type": "3"
      },
      "path": [
        "spacing",
        "3"
      ]
    },
    "4": {
      "value": "1rem",
      "comment": "Internal spacing of components such as containers or cards.",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "1rem",
        "comment": "Internal spacing of components such as containers or cards."
      },
      "name": "Spacing4",
      "attributes": {
        "category": "spacing",
        "type": "4"
      },
      "path": [
        "spacing",
        "4"
      ]
    },
    "5": {
      "value": "1.25rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "1.25rem"
      },
      "name": "Spacing5",
      "attributes": {
        "category": "spacing",
        "type": "5"
      },
      "path": [
        "spacing",
        "5"
      ]
    },
    "6": {
      "value": "1.5rem",
      "comment": "Separation of content blocks that are not related to each other.",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "1.5rem",
        "comment": "Separation of content blocks that are not related to each other."
      },
      "name": "Spacing6",
      "attributes": {
        "category": "spacing",
        "type": "6"
      },
      "path": [
        "spacing",
        "6"
      ]
    },
    "7": {
      "value": "1.75rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "1.75rem"
      },
      "name": "Spacing7",
      "attributes": {
        "category": "spacing",
        "type": "7"
      },
      "path": [
        "spacing",
        "7"
      ]
    },
    "8": {
      "value": "2rem",
      "comment": "Spacing between page elements and content.",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "2rem",
        "comment": "Spacing between page elements and content."
      },
      "name": "Spacing8",
      "attributes": {
        "category": "spacing",
        "type": "8"
      },
      "path": [
        "spacing",
        "8"
      ]
    },
    "9": {
      "value": "2.25rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "2.25rem"
      },
      "name": "Spacing9",
      "attributes": {
        "category": "spacing",
        "type": "9"
      },
      "path": [
        "spacing",
        "9"
      ]
    },
    "10": {
      "value": "2.5rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "2.5rem"
      },
      "name": "Spacing10",
      "attributes": {
        "category": "spacing",
        "type": "10"
      },
      "path": [
        "spacing",
        "10"
      ]
    },
    "11": {
      "value": "2.75rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "2.75rem"
      },
      "name": "Spacing11",
      "attributes": {
        "category": "spacing",
        "type": "11"
      },
      "path": [
        "spacing",
        "11"
      ]
    },
    "12": {
      "value": "3rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "3rem"
      },
      "name": "Spacing12",
      "attributes": {
        "category": "spacing",
        "type": "12"
      },
      "path": [
        "spacing",
        "12"
      ]
    },
    "14": {
      "value": "3.5rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "3.5rem"
      },
      "name": "Spacing14",
      "attributes": {
        "category": "spacing",
        "type": "14"
      },
      "path": [
        "spacing",
        "14"
      ]
    },
    "16": {
      "value": "4rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "4rem"
      },
      "name": "Spacing16",
      "attributes": {
        "category": "spacing",
        "type": "16"
      },
      "path": [
        "spacing",
        "16"
      ]
    },
    "18": {
      "value": "4.5rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "4.5rem"
      },
      "name": "Spacing18",
      "attributes": {
        "category": "spacing",
        "type": "18"
      },
      "path": [
        "spacing",
        "18"
      ]
    },
    "20": {
      "value": "5rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "5rem"
      },
      "name": "Spacing20",
      "attributes": {
        "category": "spacing",
        "type": "20"
      },
      "path": [
        "spacing",
        "20"
      ]
    },
    "0-5": {
      "value": "0.125rem",
      "comment": "Padding of small atomic elements such as labels or chips.",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "0.125rem",
        "comment": "Padding of small atomic elements such as labels or chips."
      },
      "name": "Spacing05",
      "attributes": {
        "category": "spacing",
        "type": "0-5"
      },
      "path": [
        "spacing",
        "0-5"
      ]
    },
    "1-5": {
      "value": "0.375rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "0.375rem"
      },
      "name": "Spacing15",
      "attributes": {
        "category": "spacing",
        "type": "1-5"
      },
      "path": [
        "spacing",
        "1-5"
      ]
    },
    "2-5": {
      "value": "0.625rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "0.625rem"
      },
      "name": "Spacing25",
      "attributes": {
        "category": "spacing",
        "type": "2-5"
      },
      "path": [
        "spacing",
        "2-5"
      ]
    },
    "3-5": {
      "value": "0.875rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "0.875rem"
      },
      "name": "Spacing35",
      "attributes": {
        "category": "spacing",
        "type": "3-5"
      },
      "path": [
        "spacing",
        "3-5"
      ]
    },
    "4-5": {
      "value": "1.125rem",
      "filePath": "src/spacing/ref.json",
      "isSource": true,
      "original": {
        "value": "1.125rem"
      },
      "name": "Spacing45",
      "attributes": {
        "category": "spacing",
        "type": "4-5"
      },
      "path": [
        "spacing",
        "4-5"
      ]
    }
  },
  "font": {
    "size": {
      "3": {
        "value": "0.75rem",
        "filePath": "src/typography/ref.json",
        "isSource": true,
        "original": {
          "value": "0.75rem"
        },
        "name": "FontSize3",
        "attributes": {
          "category": "font",
          "type": "size",
          "item": "3"
        },
        "path": [
          "font",
          "size",
          "3"
        ]
      },
      "4": {
        "value": "1rem",
        "filePath": "src/typography/ref.json",
        "isSource": true,
        "original": {
          "value": "1rem"
        },
        "name": "FontSize4",
        "attributes": {
          "category": "font",
          "type": "size",
          "item": "4"
        },
        "path": [
          "font",
          "size",
          "4"
        ]
      },
      "5": {
        "value": "1.25rem",
        "filePath": "src/typography/ref.json",
        "isSource": true,
        "original": {
          "value": "1.25rem"
        },
        "name": "FontSize5",
        "attributes": {
          "category": "font",
          "type": "size",
          "item": "5"
        },
        "path": [
          "font",
          "size",
          "5"
        ]
      },
      "6": {
        "value": "1.5rem",
        "filePath": "src/typography/ref.json",
        "isSource": true,
        "original": {
          "value": "1.5rem"
        },
        "name": "FontSize6",
        "attributes": {
          "category": "font",
          "type": "size",
          "item": "6"
        },
        "path": [
          "font",
          "size",
          "6"
        ]
      },
      "7": {
        "value": "1.75rem",
        "filePath": "src/typography/ref.json",
        "isSource": true,
        "original": {
          "value": "1.75rem"
        },
        "name": "FontSize7",
        "attributes": {
          "category": "font",
          "type": "size",
          "item": "7"
        },
        "path": [
          "font",
          "size",
          "7"
        ]
      },
      "8": {
        "value": "2rem",
        "filePath": "src/typography/ref.json",
        "isSource": true,
        "original": {
          "value": "2rem"
        },
        "name": "FontSize8",
        "attributes": {
          "category": "font",
          "type": "size",
          "item": "8"
        },
        "path": [
          "font",
          "size",
          "8"
        ]
      },
      "12": {
        "value": "3rem",
        "filePath": "src/typography/ref.json",
        "isSource": true,
        "original": {
          "value": "3rem"
        },
        "name": "FontSize12",
        "attributes": {
          "category": "font",
          "type": "size",
          "item": "12"
        },
        "path": [
          "font",
          "size",
          "12"
        ]
      },
      "16": {
        "value": "4rem",
        "filePath": "src/typography/ref.json",
        "isSource": true,
        "original": {
          "value": "4rem"
        },
        "name": "FontSize16",
        "attributes": {
          "category": "font",
          "type": "size",
          "item": "16"
        },
        "path": [
          "font",
          "size",
          "16"
        ]
      },
      "3-5": {
        "value": "0.875rem",
        "filePath": "src/typography/ref.json",
        "isSource": true,
        "original": {
          "value": "0.875rem"
        },
        "name": "FontSize35",
        "attributes": {
          "category": "font",
          "type": "size",
          "item": "3-5"
        },
        "path": [
          "font",
          "size",
          "3-5"
        ]
      },
      "4-5": {
        "value": "1.125rem",
        "filePath": "src/typography/ref.json",
        "isSource": true,
        "original": {
          "value": "1.125rem"
        },
        "name": "FontSize45",
        "attributes": {
          "category": "font",
          "type": "size",
          "item": "4-5"
        },
        "path": [
          "font",
          "size",
          "4-5"
        ]
      },
      "body": {
        "caption": {
          "value": "0.75rem",
          "comment": "It can be used for caption text and very small components like labels, inputs or chips. Must not be used for body text.",
          "filePath": "src/typography/sys.json",
          "isSource": true,
          "original": {
            "value": "{font.size.3}",
            "comment": "It can be used for caption text and very small components like labels, inputs or chips. Must not be used for body text."
          },
          "name": "FontSizeBodyCaption",
          "attributes": {
            "category": "font",
            "type": "size",
            "item": "body",
            "subitem": "caption"
          },
          "path": [
            "font",
            "size",
            "body",
            "caption"
          ]
        },
        "base": {
          "value": "0.875rem",
          "comment": "It can be used for plain text and large amounts of content.",
          "filePath": "src/typography/sys.json",
          "isSource": true,
          "original": {
            "value": "{font.size.3-5}",
            "comment": "It can be used for plain text and large amounts of content."
          },
          "name": "FontSizeBodyBase",
          "attributes": {
            "category": "font",
            "type": "size",
            "item": "body",
            "subitem": "base"
          },
          "path": [
            "font",
            "size",
            "body",
            "base"
          ]
        },
        "highlight": {
          "value": "1rem",
          "comment": "It can be used for highlighted text or titles with the lowest possible importance.",
          "filePath": "src/typography/sys.json",
          "isSource": true,
          "original": {
            "value": "{font.size.4}",
            "comment": "It can be used for highlighted text or titles with the lowest possible importance."
          },
          "name": "FontSizeBodyHighlight",
          "attributes": {
            "category": "font",
            "type": "size",
            "item": "body",
            "subitem": "highlight"
          },
          "path": [
            "font",
            "size",
            "body",
            "highlight"
          ]
        }
      },
      "title": {
        "h1": {
          "value": "2rem",
          "comment": "Main hierarchy headings, reserved for a single use per page.",
          "filePath": "src/typography/sys.json",
          "isSource": true,
          "original": {
            "value": "{font.size.8}",
            "comment": "Main hierarchy headings, reserved for a single use per page."
          },
          "name": "FontSizeTitleH1",
          "attributes": {
            "category": "font",
            "type": "size",
            "item": "title",
            "subitem": "h1"
          },
          "path": [
            "font",
            "size",
            "title",
            "h1"
          ]
        },
        "h2": {
          "value": "1.75rem",
          "comment": "Secondary hierarchy headings that are used to divide large sections of content on a page",
          "filePath": "src/typography/sys.json",
          "isSource": true,
          "original": {
            "value": "{font.size.7}",
            "comment": "Secondary hierarchy headings that are used to divide large sections of content on a page"
          },
          "name": "FontSizeTitleH2",
          "attributes": {
            "category": "font",
            "type": "size",
            "item": "title",
            "subitem": "h2"
          },
          "path": [
            "font",
            "size",
            "title",
            "h2"
          ]
        },
        "h3": {
          "value": "1.5rem",
          "filePath": "src/typography/sys.json",
          "isSource": true,
          "original": {
            "value": "{font.size.6}"
          },
          "name": "FontSizeTitleH3",
          "attributes": {
            "category": "font",
            "type": "size",
            "item": "title",
            "subitem": "h3"
          },
          "path": [
            "font",
            "size",
            "title",
            "h3"
          ]
        },
        "h4": {
          "value": "1.25rem",
          "comment": "It can be used for low hierarchy headings with the second lowest possible importance.",
          "filePath": "src/typography/sys.json",
          "isSource": true,
          "original": {
            "value": "{font.size.5}",
            "comment": "It can be used for low hierarchy headings with the second lowest possible importance."
          },
          "name": "FontSizeTitleH4",
          "attributes": {
            "category": "font",
            "type": "size",
            "item": "title",
            "subitem": "h4"
          },
          "path": [
            "font",
            "size",
            "title",
            "h4"
          ]
        },
        "h5": {
          "value": "1rem",
          "comment": "It can be used for highlighted text or titles with the lowest possible importance.",
          "filePath": "src/typography/sys.json",
          "isSource": true,
          "original": {
            "value": "{font.size.4}",
            "comment": "It can be used for highlighted text or titles with the lowest possible importance."
          },
          "name": "FontSizeTitleH5",
          "attributes": {
            "category": "font",
            "type": "size",
            "item": "title",
            "subitem": "h5"
          },
          "path": [
            "font",
            "size",
            "title",
            "h5"
          ]
        },
        "h6": {
          "value": "0.875rem",
          "filePath": "src/typography/sys.json",
          "isSource": true,
          "original": {
            "value": "{font.size.3-5}"
          },
          "name": "FontSizeTitleH6",
          "attributes": {
            "category": "font",
            "type": "size",
            "item": "title",
            "subitem": "h6"
          },
          "path": [
            "font",
            "size",
            "title",
            "h6"
          ]
        }
      }
    },
    "family": {
      "sans": {
        "value": "Geist, -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', arial, sans-serif",
        "comment": "Font family value by default, to use in css and set components font.",
        "filePath": "src/typography/sys.json",
        "isSource": true,
        "original": {
          "value": "Geist, -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', arial, sans-serif",
          "comment": "Font family value by default, to use in css and set components font."
        },
        "name": "FontFamilySans",
        "attributes": {
          "category": "font",
          "type": "family",
          "item": "sans"
        },
        "path": [
          "font",
          "family",
          "sans"
        ]
      },
      "mono": {
        "value": "Geist Mono, 'Roboto Mono', monospace",
        "comment": "Monospace font family value for usage within code blocks and code elements.",
        "filePath": "src/typography/sys.json",
        "isSource": true,
        "original": {
          "value": "Geist Mono, 'Roboto Mono', monospace",
          "comment": "Monospace font family value for usage within code blocks and code elements."
        },
        "name": "FontFamilyMono",
        "attributes": {
          "category": "font",
          "type": "family",
          "item": "mono"
        },
        "path": [
          "font",
          "family",
          "mono"
        ]
      }
    },
    "weight": {
      "regular": {
        "value": "400",
        "comment": "Plain text with regular weight, can be combined with highlight, base or caption font-size.",
        "filePath": "src/typography/sys.json",
        "isSource": true,
        "original": {
          "value": "400",
          "comment": "Plain text with regular weight, can be combined with highlight, base or caption font-size."
        },
        "name": "FontWeightRegular",
        "attributes": {
          "category": "font",
          "type": "weight",
          "item": "regular"
        },
        "path": [
          "font",
          "weight",
          "regular"
        ]
      },
      "medium": {
        "value": "500",
        "comment": "Plain text with medium weight, can be combined with every font-size.",
        "filePath": "src/typography/sys.json",
        "isSource": true,
        "original": {
          "value": "500",
          "comment": "Plain text with medium weight, can be combined with every font-size."
        },
        "name": "FontWeightMedium",
        "attributes": {
          "category": "font",
          "type": "weight",
          "item": "medium"
        },
        "path": [
          "font",
          "weight",
          "medium"
        ]
      },
      "bold": {
        "value": "600",
        "comment": "Plain text with semi-bold weight, can be combined with highlight, base or caption font-size.",
        "filePath": "src/typography/sys.json",
        "isSource": true,
        "original": {
          "value": "600",
          "comment": "Plain text with semi-bold weight, can be combined with highlight, base or caption font-size."
        },
        "name": "FontWeightBold",
        "attributes": {
          "category": "font",
          "type": "weight",
          "item": "bold"
        },
        "path": [
          "font",
          "weight",
          "bold"
        ]
      }
    }
  },
  "line": {
    "height": {
      "4": {
        "value": "1rem",
        "filePath": "src/typography/ref.json",
        "isSource": true,
        "original": {
          "value": "1rem"
        },
        "name": "LineHeight4",
        "attributes": {
          "category": "line",
          "type": "height",
          "item": "4"
        },
        "path": [
          "line",
          "height",
          "4"
        ]
      },
      "5": {
        "value": "1.25rem",
        "filePath": "src/typography/ref.json",
        "isSource": true,
        "original": {
          "value": "1.25rem"
        },
        "name": "LineHeight5",
        "attributes": {
          "category": "line",
          "type": "height",
          "item": "5"
        },
        "path": [
          "line",
          "height",
          "5"
        ]
      },
      "6": {
        "value": "1.5rem",
        "filePath": "src/typography/ref.json",
        "isSource": true,
        "original": {
          "value": "1.5rem"
        },
        "name": "LineHeight6",
        "attributes": {
          "category": "line",
          "type": "height",
          "item": "6"
        },
        "path": [
          "line",
          "height",
          "6"
        ]
      },
      "7": {
        "value": "1.75rem",
        "filePath": "src/typography/ref.json",
        "isSource": true,
        "original": {
          "value": "1.75rem"
        },
        "name": "LineHeight7",
        "attributes": {
          "category": "line",
          "type": "height",
          "item": "7"
        },
        "path": [
          "line",
          "height",
          "7"
        ]
      },
      "8": {
        "value": "2rem",
        "filePath": "src/typography/ref.json",
        "isSource": true,
        "original": {
          "value": "2rem"
        },
        "name": "LineHeight8",
        "attributes": {
          "category": "line",
          "type": "height",
          "item": "8"
        },
        "path": [
          "line",
          "height",
          "8"
        ]
      },
      "10": {
        "value": "2.5rem",
        "filePath": "src/typography/ref.json",
        "isSource": true,
        "original": {
          "value": "2.5rem"
        },
        "name": "LineHeight10",
        "attributes": {
          "category": "line",
          "type": "height",
          "item": "10"
        },
        "path": [
          "line",
          "height",
          "10"
        ]
      },
      "11": {
        "value": "2.75rem",
        "filePath": "src/typography/ref.json",
        "isSource": true,
        "original": {
          "value": "2.75rem"
        },
        "name": "LineHeight11",
        "attributes": {
          "category": "line",
          "type": "height",
          "item": "11"
        },
        "path": [
          "line",
          "height",
          "11"
        ]
      },
      "3-5": {
        "value": "0.875rem",
        "filePath": "src/typography/ref.json",
        "isSource": true,
        "original": {
          "value": "0.875rem"
        },
        "name": "LineHeight35",
        "attributes": {
          "category": "line",
          "type": "height",
          "item": "3-5"
        },
        "path": [
          "line",
          "height",
          "3-5"
        ]
      },
      "4-5": {
        "value": "1.125rem",
        "filePath": "src/typography/ref.json",
        "isSource": true,
        "original": {
          "value": "1.125rem"
        },
        "name": "LineHeight45",
        "attributes": {
          "category": "line",
          "type": "height",
          "item": "4-5"
        },
        "path": [
          "line",
          "height",
          "4-5"
        ]
      },
      "body": {
        "caption": {
          "value": "1rem",
          "comment": "Combined use with: font-size-body-caption",
          "filePath": "src/typography/sys.json",
          "isSource": true,
          "original": {
            "value": "{line.height.4}",
            "comment": "Combined use with: font-size-body-caption"
          },
          "name": "LineHeightBodyCaption",
          "attributes": {
            "category": "line",
            "type": "height",
            "item": "body",
            "subitem": "caption"
          },
          "path": [
            "line",
            "height",
            "body",
            "caption"
          ]
        },
        "base": {
          "value": "1.25rem",
          "comment": "Combined use with: font-size-body-base",
          "filePath": "src/typography/sys.json",
          "isSource": true,
          "original": {
            "value": "{line.height.5}",
            "comment": "Combined use with: font-size-body-base"
          },
          "name": "LineHeightBodyBase",
          "attributes": {
            "category": "line",
            "type": "height",
            "item": "body",
            "subitem": "base"
          },
          "path": [
            "line",
            "height",
            "body",
            "base"
          ]
        },
        "highlight": {
          "value": "1.5rem",
          "comment": "Combined use with: font-size-body-highlight",
          "filePath": "src/typography/sys.json",
          "isSource": true,
          "original": {
            "value": "{line.height.6}",
            "comment": "Combined use with: font-size-body-highlight"
          },
          "name": "LineHeightBodyHighlight",
          "attributes": {
            "category": "line",
            "type": "height",
            "item": "body",
            "subitem": "highlight"
          },
          "path": [
            "line",
            "height",
            "body",
            "highlight"
          ]
        }
      },
      "title": {
        "h1": {
          "value": "2.5rem",
          "comment": "Combined use with: font-size-title-h1",
          "filePath": "src/typography/sys.json",
          "isSource": true,
          "original": {
            "value": "{line.height.10}",
            "comment": "Combined use with: font-size-title-h1"
          },
          "name": "LineHeightTitleH1",
          "attributes": {
            "category": "line",
            "type": "height",
            "item": "title",
            "subitem": "h1"
          },
          "path": [
            "line",
            "height",
            "title",
            "h1"
          ]
        },
        "h2": {
          "value": "2rem",
          "comment": "Combined use with: font-size-title-h2",
          "filePath": "src/typography/sys.json",
          "isSource": true,
          "original": {
            "value": "{line.height.8}",
            "comment": "Combined use with: font-size-title-h2"
          },
          "name": "LineHeightTitleH2",
          "attributes": {
            "category": "line",
            "type": "height",
            "item": "title",
            "subitem": "h2"
          },
          "path": [
            "line",
            "height",
            "title",
            "h2"
          ]
        },
        "h3": {
          "value": "1.75rem",
          "comment": "Combined use with: font-size-title-h3",
          "filePath": "src/typography/sys.json",
          "isSource": true,
          "original": {
            "value": "{line.height.7}",
            "comment": "Combined use with: font-size-title-h3"
          },
          "name": "LineHeightTitleH3",
          "attributes": {
            "category": "line",
            "type": "height",
            "item": "title",
            "subitem": "h3"
          },
          "path": [
            "line",
            "height",
            "title",
            "h3"
          ]
        },
        "h4": {
          "value": "1.5rem",
          "comment": "Combined use with: font-size-title-h4",
          "filePath": "src/typography/sys.json",
          "isSource": true,
          "original": {
            "value": "{line.height.6}",
            "comment": "Combined use with: font-size-title-h4"
          },
          "name": "LineHeightTitleH4",
          "attributes": {
            "category": "line",
            "type": "height",
            "item": "title",
            "subitem": "h4"
          },
          "path": [
            "line",
            "height",
            "title",
            "h4"
          ]
        },
        "h5": {
          "value": "1.5rem",
          "comment": "Combined use with: font-size-title-h5",
          "filePath": "src/typography/sys.json",
          "isSource": true,
          "original": {
            "value": "{line.height.6}",
            "comment": "Combined use with: font-size-title-h5"
          },
          "name": "LineHeightTitleH5",
          "attributes": {
            "category": "line",
            "type": "height",
            "item": "title",
            "subitem": "h5"
          },
          "path": [
            "line",
            "height",
            "title",
            "h5"
          ]
        },
        "h6": {
          "value": "1.25rem",
          "comment": "Combined use with: font-size-title-h6",
          "filePath": "src/typography/sys.json",
          "isSource": true,
          "original": {
            "value": "{line.height.5}",
            "comment": "Combined use with: font-size-title-h6"
          },
          "name": "LineHeightTitleH6",
          "attributes": {
            "category": "line",
            "type": "height",
            "item": "title",
            "subitem": "h6"
          },
          "path": [
            "line",
            "height",
            "title",
            "h6"
          ]
        }
      }
    }
  },
  "zIndex": {
    "100": {
      "value": "100",
      "comment": "The minimum z-index value, use not defined.",
      "filePath": "src/zIndex/sys.json",
      "isSource": true,
      "original": {
        "value": "100",
        "comment": "The minimum z-index value, use not defined."
      },
      "name": "ZIndex100",
      "attributes": {
        "category": "zIndex",
        "type": "100"
      },
      "path": [
        "zIndex",
        "100"
      ]
    },
    "200": {
      "value": "200",
      "filePath": "src/zIndex/sys.json",
      "isSource": true,
      "original": {
        "value": "200"
      },
      "name": "ZIndex200",
      "attributes": {
        "category": "zIndex",
        "type": "200"
      },
      "path": [
        "zIndex",
        "200"
      ]
    },
    "300": {
      "value": "300",
      "filePath": "src/zIndex/sys.json",
      "isSource": true,
      "original": {
        "value": "300"
      },
      "name": "ZIndex300",
      "attributes": {
        "category": "zIndex",
        "type": "300"
      },
      "path": [
        "zIndex",
        "300"
      ]
    },
    "400": {
      "value": "400",
      "filePath": "src/zIndex/sys.json",
      "isSource": true,
      "original": {
        "value": "400"
      },
      "name": "ZIndex400",
      "attributes": {
        "category": "zIndex",
        "type": "400"
      },
      "path": [
        "zIndex",
        "400"
      ]
    },
    "500": {
      "value": "500",
      "filePath": "src/zIndex/sys.json",
      "isSource": true,
      "original": {
        "value": "500"
      },
      "name": "ZIndex500",
      "attributes": {
        "category": "zIndex",
        "type": "500"
      },
      "path": [
        "zIndex",
        "500"
      ]
    },
    "600": {
      "value": "600",
      "comment": "Value commonly used for overlay elements, modals and sidebars.",
      "filePath": "src/zIndex/sys.json",
      "isSource": true,
      "original": {
        "value": "600",
        "comment": "Value commonly used for overlay elements, modals and sidebars."
      },
      "name": "ZIndex600",
      "attributes": {
        "category": "zIndex",
        "type": "600"
      },
      "path": [
        "zIndex",
        "600"
      ]
    },
    "700": {
      "value": "700",
      "comment": "Value commonly used for modals and sidebars.",
      "filePath": "src/zIndex/sys.json",
      "isSource": true,
      "original": {
        "value": "700",
        "comment": "Value commonly used for modals and sidebars."
      },
      "name": "ZIndex700",
      "attributes": {
        "category": "zIndex",
        "type": "700"
      },
      "path": [
        "zIndex",
        "700"
      ]
    },
    "800": {
      "value": "800",
      "comment": "Value commonly used floating components like toasts, tooltips and popovers.",
      "filePath": "src/zIndex/sys.json",
      "isSource": true,
      "original": {
        "value": "800",
        "comment": "Value commonly used floating components like toasts, tooltips and popovers."
      },
      "name": "ZIndex800",
      "attributes": {
        "category": "zIndex",
        "type": "800"
      },
      "path": [
        "zIndex",
        "800"
      ]
    },
    "900": {
      "value": "900",
      "comment": "The highest z-index value, use not defined.",
      "filePath": "src/zIndex/sys.json",
      "isSource": true,
      "original": {
        "value": "900",
        "comment": "The highest z-index value, use not defined."
      },
      "name": "ZIndex900",
      "attributes": {
        "category": "zIndex",
        "type": "900"
      },
      "path": [
        "zIndex",
        "900"
      ]
    }
  }
};
